module.exports = __webpack_public_path__ + "media/images/icons/benefits_playlist-f847b3e33a827f584696a780cf1aaf0b.svg";